import { func, oneOfType, shape, PropTypes } from 'prop-types';

export const refType = oneOfType([func, shape({ current: PropTypes.any })]);
